import { StatType } from '@loc/server/enums/music'
import { useLatest, useThrottleEffect } from 'ahooks'

import { useAnalyticsData } from '@/hooks/analyticsData'


import { useGlobalAudioPlayer } from '@/hooks/audio/store';
import { useState, useCallback, useEffect } from 'react';
export function useAudioTrack() {
  const { trackUserActivityThrottle } = useAnalyticsData()

  const globalPlayer = useGlobalAudioPlayer()

  const durationInSeconds = globalPlayer.meta?.duration
  const durationInSecondsRef = useLatest(durationInSeconds ?? 0)

  const [canTrack, setCanTrack] = useState(true)
  const canTrackRef = useLatest(canTrack)
  // 实际播放时长,单位秒
  const [playbackDuration, setPlaybackDuration] = useState(0)
  const playbackDurationRef = useLatest(playbackDuration)

  const onTrackPlay = useCallback(() => {
    if (globalPlayer.meta?.id) {
      trackUserActivityThrottle([
        {
          uuid: globalPlayer.meta?.id,
          statType: StatType.Play,
        },
      ])
    }
  }, [globalPlayer.meta?.id, trackUserActivityThrottle])

  useThrottleEffect(
    () => {
      if (playbackDurationRef.current === 0) {
        setPlaybackDuration(3)
        return
      }
      setPlaybackDuration(playbackDurationRef.current + 3)
    },
    [globalPlayer.currentTimeInSeconds],
    {
      wait: 3000,
    },
  )

  // 切换音频时，重置播放时长
  useEffect(() => {
    setPlaybackDuration(0)
    setCanTrack(true)
  }, [globalPlayer.meta?.src])

  // 情况一：播放30s
  useEffect(() => {
    if (playbackDurationRef.current >= 30 && canTrackRef.current) {
      // console.log(playbackDurationRef.current, 'playbackDurationRef.current1')
      // console.log(canTrackRef.current, 'canTrackRef.current1')
      onTrackPlay()
      setCanTrack(false)
    }
  }, [canTrackRef, onTrackPlay, playbackDuration, playbackDurationRef])

  // 情况二：播放结束时，播放时长大于等于音频时长
  useEffect(() => {
    if (
      canTrackRef.current &&
      playbackDurationRef.current > 0 &&
      durationInSecondsRef.current > 0 &&
      playbackDurationRef.current >= durationInSecondsRef.current
    ) {
      // console.log(playbackDurationRef.current, 'playbackDurationRef.current2')
      // console.log(durationInSecondsRef.current, 'durationInSecondsRef.current2')
      onTrackPlay()
    }
    // 播放结束时，重置播放时长
    setCanTrack(true)
    setPlaybackDuration(0)
  }, [onTrackPlay, canTrackRef, playbackDurationRef, durationInSecondsRef])
}
